import client from './client';

export const listEstates = (params) =>
  client.get('/estates', { params }).then((r) => r.data);

export const getEstate = (id) =>
  client.get(`/estates/${id}`).then((r) => r.data);

export const createEstate = (data) =>
  client.post('/estates', data).then((r) => r.data);

export const updateEstate = (id, data) =>
  client.put(`/estates/${id}`, data).then((r) => r.data);

export const deleteEstate = (id) =>
  client.delete(`/estates/${id}`).then((r) => r.data);
